export default __webpack_public_path__ + "static/media/7.306197c7.png";